import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import sharedStyle from 'assets/jss/material-kit-react/views/sharedSections/sharedStyle.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import { navigateTo } from 'gatsby-link';

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    const form = e.target;
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': 'contact',
        ...this.state
      }),
    })
      .then(() => navigateTo(form.getAttribute('action')))
      .catch(error => alert(error));
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.sections}>
        <div className={classes.container}>
          <div id="Intro">
            <GridContainer>
              <GridItem md={12} sm={12}>
                <div className={classes.container}>
                  <form
                    name="contact"
                    method="post"
                    action="/message-sent"
                    data-netlify="true"
                    data-netlify-honeypot="bot-field"
                    onSubmit={this.handleSubmit}
                  >
                    <GridContainer>
                      <input type="hidden" name="form-name" value="contact" />
                      <p hidden>
                        <label>
                          Don’t fill this out:
                          <input
                            name="bot-field"
                            onChange={this.handleChange}
                          />
                        </label>
                      </p>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Name"
                          id="float"
                          type="text"
                          formControlProps={{
                            required: true,
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: 'text',
                            name: 'Name',
                            onChange: this.handleChange,
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Email address"
                          id="float"
                          formControlProps={{
                            fullWidth: true,
                            required: true,
                          }}
                          inputProps={{
                            type: 'email',
                            name: 'Email address',
                            onChange: this.handleChange,
                          }}
                        />
                      </GridItem>


                      <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.textCenter}>
                          <Button color="primary" type="submit">
                            Send
                          </Button>
                        </div>
                      </GridItem>
                    </GridContainer>
                  </form>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(sharedStyle)(ContactForm);
